<template>
  <Dropdown style="width: 100%" :disabled="submitPending"
    :modelValue="selectedSensorModelEnum"
    :options="options"
    :optionLabel="option => option.label"
    :optionValue="option => option.value"
    :optionDisabled="option => option.disabled"
    @update:modelValue="value => submit(value)"
  >
    <template #value v-if="channel.sensorModelNumber.value == null">
      Unrecognized model
    </template>
  </Dropdown>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import store from "./store.js";

let props = defineProps([
  "channel",
  "sensorModels",
  "sensorModelConfigurationMode"
]);

let sensorModels = computed(() => {
  let session = store.sessions[0];
  return session.system.controller.sensorModels.children;
});

let selectableSensorModels = computed(() => {
  if (props.sensorModelConfigurationMode == "manual")
    return props.sensorModels;
  else
    return props.sensorModels.filter(model => model.sensorType.value == selectedSensorModel.value?.sensorType.value);
});

let options = computed(() => {
  return sensorModels.value.map((sensorModel, index) => ({
    label: sensorModel.name.value,
    value: index,
    disabled: !selectableSensorModels.value.includes(sensorModel)
  }));
});

let configuredSensorModelEnum = computed(() => {
  return props.channel.sensorModelNumber.value;
});

let selectedSensorModelEnum = ref(null);
watch(configuredSensorModelEnum, () => {
  selectedSensorModelEnum.value = configuredSensorModelEnum.value;
}, { immediate: true });

let selectedSensorModel = computed(() => {
  return props.sensorModels[selectedSensorModelEnum.value];
});

let submitPending = ref(false);
function submit(sensorModelEnum) {
  submitPending.value = true;
  selectedSensorModelEnum.value = sensorModelEnum;
  store.sessions[0].changeSettings([{
    handle: props.channel.sensorModelNumber.handle,
    value: parseInt(sensorModelEnum)
  }], () => submitPending.value = false);
}
</script>
